import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
  FormHelperText,
} from "@chakra-ui/react";
const Paragraph = ({ options, formik, id }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const paragraphErrors =
    Object.keys(formik.errors).length &&
    formik.errors.paragraph &&
    formik.errors.paragraph.length &&
    formik.errors.paragraph[id];
  const paragraphTouched =
    Object.keys(formik.touched).length &&
    formik.touched.paragraph &&
    formik.touched.paragraph.length &&
    formik.touched.paragraph[id];
  const hasError = paragraphTouched && paragraphErrors;
  const onChangeparagraph = (e, id) => {
    const setValues = formik.setValues;
    const formikValues = formik.values;
    const paragraph = [...formik.values.paragraph];
    const currentValues = e.target.value;
    let newUpdateValue = true;
    Object.keys(formikValues.paragraph).some((field, i) => {
      Object.keys(formikValues.paragraph[i]) == e.target.name &&
        (formikValues.paragraph[i][e.target.name] = e.target.value);
      if (
        formikValues.paragraph.length - 1 == i &&
        Object.keys(formikValues.paragraph[i]) == e.target.name
      ) {
        newUpdateValue = false;
      }
      if (!newUpdateValue) {
        return;
      }
    });
    if (newUpdateValue) {
      const currentValuesWithId = {
        [e.target.name]: currentValues,
      };
      paragraph.push(currentValuesWithId);
    }
    setValues({ ...formikValues, paragraph });
  };
  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="paragraph" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <Textarea
        size="sm"
        //				id="paragraph"
        name={`paragraph.${id}.name`}
        type="text"
        placeholder={options.placeholder}
        onChange={(e) => {
          onChangeparagraph(e, id);
        }}
        // onChange={formik.handleChange}
        // onBlur={formik.handleBlur}
        // value={formik.values.paragraph}
        value={
          formik.values && formik.values["paragraph"][`paragraph.${id}.name`]
        }
      />
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.paragraph}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default Paragraph;
